import { Typo3ReportsLiftAndSlope } from '@/types'
import { BaseLink, StatusChip } from '@/ui/components'
import { memo } from 'react'
import IconComponent from '../../Icon'
import MapFrame from '../../MapFrame'
import CardSlope from './CardSlope'

interface Props extends Typo3ReportsLiftAndSlope {
  isLayoutWinter: boolean
}

const AccordionBody = ({ isLayoutWinter, ...data }: Props) => (
  <div className={''}>
    {data?.linkMap && isLayoutWinter && (
      <BaseLink
        href={data?.linkMap?.replace('&mini=1', '')}
        isTransition={false}
        nextLink={false}
        target={'_blank'}
      >
        <MapFrame src={data?.linkMap} />
      </BaseLink>
    )}
    {data?.listLifts?.map((item, i) => (
      <div className={'pb-md border-t border-neutral-300'} key={i?.toString()}>
        <div className="pb-md flex justify-between">
          <div>
            <div className="mb-sm flex">
              <StatusChip
                status={item.liveStatus === 'OPEN' ? 'success' : 'error'}
              />
            </div>

            <div className="textstyle-lg-bold">{item.title}</div>
            <div className="textstyle-sm-regular text-neutral-400">
              {item.typeLabel}
            </div>
          </div>
          <div className="flex size-14 items-center justify-center bg-neutral-300">
            {item?.type && item?.type !== '' && (
              <IconComponent icon={item?.type} className="size-8" />
            )}
          </div>
        </div>
        <div className={'pb-md'}>
          {item?.slopes?.map((slope, i) => (
            <CardSlope key={i?.toString()} {...slope} />
          ))}
        </div>
      </div>
    ))}
  </div>
)

export default memo(AccordionBody)
